import { GeofenceAPIService } from './AxiosAPIService';
import { logger } from './SharedService';
import {
  Geofence,
  GeofencesResponse,
  GeofenceEventsResponse,
  PostGeofenceRequest,
  PatchGeofenceRequest,
  DeleteGeofenceRequest,
} from '../types/Geofences';

export const getGeofenceById = async (fleetId: string, geofenceId: string): Promise<Geofence> => {
  logger.info('GET', 'REQUEST', 'getGeofenceById', `/fleets/${fleetId}/geofence-fleet/${geofenceId}`);
  const { data } = await GeofenceAPIService.api.get<Geofence>(`/fleets/${fleetId}/geofence-fleet/${geofenceId}`);
  logger.info('GET', 'RESPONSE', 'getGeofenceById', data);
  return data;
};

export const getGeofencesList = async (fleetId: string): Promise<GeofencesResponse> => {
  logger.info('GET', 'REQUEST', 'getGeofencesList', `/fleets/${fleetId}/geofence-fleet?limit=1000&skip=0`);
  const { data } = await GeofenceAPIService.api.get<GeofencesResponse>(`/fleets/${fleetId}/geofence-fleet?limit=1000&skip=0`);
  logger.info('GET', 'RESPONSE', 'getGeofencesList', data);
  return data;
};

export const getGeofenceEvents = async (fleetId: string, query: string): Promise<GeofenceEventsResponse> => {
  logger.info('GET', 'REQUEST', 'getGeofenceEvents', `/fleets/${fleetId}/intersections${query}`);
  const { data } = await GeofenceAPIService.api.get<GeofenceEventsResponse>(`/fleets/${fleetId}/intersections${query}`);
  logger.info('GET', 'RESPONSE', 'getGeofenceEvents', data);
  return data;
};

export const postGeofence = async (payload: PostGeofenceRequest): Promise<Geofence> => {
  logger.info('POST', 'REQUEST', 'postGeofence', `/fleets/${payload.fleetId}/geofence-fleet`);
  const { data } = await GeofenceAPIService.api.post<Geofence>(`/fleets/${payload.fleetId}/geofence-fleet`, {
    name: payload.name,
    location: payload.location,
  });
  logger.info('POST', 'RESPONSE', 'postGeofence', data);
  return data;
};

export const patchGeofence = async (payload: PatchGeofenceRequest): Promise<Geofence> => {
  logger.info('PATCH', 'REQUEST', 'patchGeofence', `/fleets/${payload.fleetId}/geofence-fleet/${payload.id}`);
  const { data } = await GeofenceAPIService.api.patch<Geofence>(`/fleets/${payload.fleetId}/geofence-fleet/${payload.id}`, {
    name: payload.name,
    location: payload.location,
  });
  logger.info('PATCH', 'RESPONSE', 'patchGeofence', data);
  return data;
};

export const deleteGeofence = async (payload: DeleteGeofenceRequest): Promise<Geofence> => {
  logger.info('DELETE', 'REQUEST', 'deleteGeofence', `/fleets/${payload.fleetId}/geofence-fleet/${payload.id}`);
  const { data } = await GeofenceAPIService.api.delete<Geofence>(`/fleets/${payload.fleetId}/geofence-fleet/${payload.id}`);
  logger.info('DELETE', 'RESPONSE', 'deleteGeofence', 'OK');
  return data;
};
